"use client"

import { useEffect, useState } from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { DENSITIES, applyDensity, getStoredDensity, type Density } from '@/lib/density'
import { useT } from '@/lib/i18n'

/**
 * Settings → გარეგნობა: how much fits on THIS device's screen (2026-09-27).
 * Per device like the palette — the till's big monitor and the owner's
 * laptop want different answers. The change is instant; nothing reloads.
 */
export function DensityPicker() {
  const t = useT()
  const [density, setDensity] = useState<Density>('auto')
  useEffect(() => { setDensity(getStoredDensity()) }, [])

  const choose = (d: Density) => {
    setDensity(d)
    applyDensity(d)
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" role="radiogroup" aria-label={t('density.picker.1')}>
      {DENSITIES.map((d) => (
        <button
          key={d.key}
          type="button"
          role="radio"
          aria-checked={density === d.key}
          onClick={() => choose(d.key)}
          className={cn(
            'relative text-left rounded-xl border px-3.5 py-3 transition-colors',
            density === d.key
              ? 'border-primary bg-primary/10'
              : 'border-border hover:bg-muted/60',
          )}
        >
          <span className={cn('block text-sm font-bold', density === d.key ? 'text-primary' : 'text-foreground')}>{t(d.label)}</span>
          <span className="block text-[12px] text-muted-foreground mt-0.5 leading-snug">{t(d.hint)}</span>
          {density === d.key && <Check className="absolute top-3 right-3 size-4 text-primary" />}
        </button>
      ))}
    </div>
  )
}
